/**
 * Friendly-username validation constants. Mirrors the server-side rules
 * in `predictions-api/src/users/username.validator.ts` so client and
 * server agree on what's acceptable. Server is the source of truth.
 */
export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 20;
export const USERNAME_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9_.-]*$/;

/**
 * Client-side pre-flight validator. Returns null if the value passes
 * the basic shape rules, or a human-readable reason otherwise.
 *
 * Reserved-word and uniqueness checks are intentionally server-only —
 * the UI surfaces those via 400 / 409 responses.
 */
export function validateUsernameClient(value: string): string | null {
  const trimmed = value.trim();
  if (trimmed.length < USERNAME_MIN_LENGTH) {
    return `Must be at least ${USERNAME_MIN_LENGTH} characters`;
  }
  if (trimmed.length > USERNAME_MAX_LENGTH) {
    return `Must be at most ${USERNAME_MAX_LENGTH} characters`;
  }
  if (!USERNAME_PATTERN.test(trimmed)) {
    return 'Letters, digits, dots, hyphens, underscores. Must start with a letter or digit.';
  }
  return null;
}
